module.exports = __webpack_public_path__ + "static/media/assistance-commerciale.72548df2.jpg";